import './App.css';
import { Home } from './pages/Home';
import GlobalStyle from './styles/GlobalStyles';

function App() {
  return (
    <>
    <GlobalStyle/>
      <Home />
      </>

  );
}

export default App;
